import React from "react";
import { Twitter } from "../../basic/icons/twitter";
import { Facebook } from "../../basic/icons/facebook";
import PropTypes from "prop-types";
import "./card-share.m.css";

export const CardShareTemplate = ({ className, twitterUrl, fbUrl, gplusUrl, color }) => {
  return (
    <div className={className}>
      <a styleName="icon" href={twitterUrl} target="_blank" rel="noopener noreferrer">
        <Twitter color={color} />
      </a>
      <a styleName="icon" href={fbUrl} target="_blank" rel="noopener noreferrer">
        <Facebook color={color} />
      </a>
    </div>
  );
};
CardShareTemplate.propTypes = {
  color: PropTypes.string,
  twitterUrl: PropTypes.string,
  fbUrl: PropTypes.string,
  gplusUrl: PropTypes.string,
  className: PropTypes.string
};
